<template>
  <el-cascader
    @change="handel"
    :placeholder="$t('lang.Please select an organization')"
    :options="$store.state.queryUnitTreeList"
    :props="{ checkStrictly: true ,label:'name',children:'subUnit',value:'unitNo'}"
    clearable></el-cascader>
</template>

<script>
export default {
  data() {
    return {
      options: [],
      unitNo: [],
    }

  },
  methods: {
    handel(val) {
      this.$emit('change', val);
    },
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/queryUnitTree.vue